import baseConfig from "../config.js";
import basicFormHelper from "../basic.form.helper.js";

//注明：如果列表中需要有编码，配置initCodeRules，则会自动加载XXDesc,XXCodeItems(XX表示数据项的属性名)
const columns:any = [{
		dataIndex: 'name',
		slots: {
			//用来自定义表头内容
			title: 'customTitle1'
		},
		scopedSlots: {
			//插槽相关customRender的值对应slot，slot-scope可以得到text,record
			customRender: 'name'
		},
	},
	{
		dataIndex: 'age',
		title: '年龄',
	},
	{
		dataIndex: 'birthday',
		title: '出生年月',
	},
	{
		dataIndex: 'sex',
		title: '性别编码',
	},
	{
		dataIndex: 'sexDesc',
		title: '性别',
	},
	{
		dataIndex: 'code',
		title: '单位类型编码',
	},
	{
		dataIndex: 'codeDesc',
		title: '单位类型',
	},
	{
		dataIndex: 'state',
		title: '状态编码',
		scopedSlots: {
			customRender: 'state'
		},
	},
	{
		dataIndex: 'stateDesc',
		title: '状态'
	},
	{
	  title: '操作',
	  dataIndex: 'operation',
	  scopedSlots: { customRender: 'operation' },
	}
];


const form:any = {
	id: "",
	name: "",
	subject: "",
	period: "",
	introduction:"",
	state: "",
	relativeIamge: ""
};


const formRules:any = {
	name: [{
			required: true,
			message: "请输入课程名称",
			trigger: "blur"
		}
	],
	subject:[
		{
			required: true,
			message: "请输入所属学科",
			trigger: "blur"
		}
	],
	period:[{
		required: true,
		message: "请选择适用学段",
		trigger: "change"
	}],
	relativeIamge: [{
		required: true,
		message: '请添加图片',
		trigger: 'blur'
	}],
	introduction: [{
		required: true,
		message: "请输入简介",
		trigger: "blur"
	}],
};

const initPageRules:any = [{ //如果是通过getCodeItemList得到编码格式的可以不写下面的dataLoadSuccess
	name: "sexList",
	loadDataUrl: "/app/json/getCodeItemList?code=sex",
	dataLoadSuccess(pageData:any, rule:any, data:any, vueData:any) {
		console.log("自定义格式>>>");
		let list = data.content;
		for (let i = 0; i < list.length; i++) {
			vueData.pageData[rule.name].push({
				name: list[i].name,
				value: list[i].value
			});
		}
	},
}, { //如果是通过getCodeItemList得到编码格式的可以不写下面的dataLoadSuccess
	name: "stateList",
	loadDataUrl: "/app/json/getCodeItemList?code=yes_no"
}, {
	name: "manySelectList",
	loadDataUrl: "/app/json/getCodeItemList?code=learning_section"
}];


/**
 * 其实就是把本页面定义的form数据,重新copy一份数据出来
 */
const copyNewForm = function() {
	let jsonStr = JSON.stringify(form);
	let newForm = JSON.parse(jsonStr);
	return newForm;
};

/**
 * 把本地页面data中定义的form转换接口所需的数据格式
 * @param {Object} pageForm
 */
const convertDbForm = function(pageForm:any) {
	let dbForm = {
		...{},
		...pageForm
	};

	let codeStr = dbForm.code + "";
	dbForm.code = codeStr;

	return dbForm;
};

/**
 * 把通过查询返回的数据格式塞入到页面data的from属性中
 * @param {Object} dbFrom
 * @param {Object} contextForm
 */

export default {
	columns,
	form,
	copyNewForm: basicFormHelper.copyNewForm,

	initPageRules,
	formRules,
	convertDbForm,

	allowUploadTypes: basicFormHelper.allowUploadTypes
}
